import { render, staticRenderFns } from "./GlobalPositionTemplate.vue?vue&type=template&id=d9a8b472&scoped=true&"
import script from "./GlobalPositionTemplate.vue?vue&type=script&lang=js&"
export * from "./GlobalPositionTemplate.vue?vue&type=script&lang=js&"
import style0 from "./GlobalPositionTemplate.vue?vue&type=style&index=0&id=d9a8b472&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9a8b472",
  null
  
)

export default component.exports